import { render, staticRenderFns } from "./RightsHolderRepertoire.vue?vue&type=template&id=1a9587f7&"
import script from "./RightsHolderRepertoire.vue?vue&type=script&lang=js&"
export * from "./RightsHolderRepertoire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports